import { useState } from 'react';
const useContentEmail = (emailContent) => {
  const [content, setContent] = useState(null);
  const [validate, setValidate] = useState(false);

  const handleChange = (e) => {
    setContent(e);
    setValidate(false);
    if (e.length <= 8) {
      setValidate(true)
    }
  };

  return [content, validate, handleChange];
};

export default useContentEmail;
